import { Box, Label } from '@medely/ui-kit';
import React from 'react';

declare global {
  interface Window {
    Intercom: any;
  }
}

export const ChatWithSupport = () => {
  const intercomMethod = (...args) => {
    if (typeof window !== 'undefined' && typeof window.Intercom === 'function') {
      console.warn('Intercom method called with args:', args);
      return window.Intercom(...args);
    }
  };

  function show() {
    intercomMethod();
  }

  return (
    <Box onClick={() => show()} pl={4}>
      <Label size="m" color="state.teal.secondary">
        Chat with support to update number
      </Label>
    </Box>
  );
};
